export var PublicRoutes = {
    Signin: '/auth/signin',
    Register: [
        '/auth/register',
        '/auth/register/:shipperconnection',
        '/account/register/:shipperconnection'
    ],
    TrackAndTrace: '/public/trackandtrace',
    Contacts: '/contacts/public'
};
//# sourceMappingURL=PublicRoutes.js.map